// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jTtkZVGH4D1cnboyBCmp {
    display: flex;
    justify-content: space-between;
    flex-grow: 1;
    width: 100%;
    margin: 40px 0 50px;
}

.xr63LNqBNzOOyaZZIsN3 {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    position: relative;
    width: 100%;
    height: 80px;
}

.hkKMVgcP38woKcfnQErX {
    text-align: center;
}

.iOVXaUW9_Wl5QZBM75Tn {
    color: var(--green);
    font-weight: 600;
}

.UiAJuGhtSB1aAUowafI3 {
    position: absolute;
    top: 18px;
    right: 0;
    width: 50%;
    height: 0;
    border-bottom: 2px dashed var(--light-gray);
    z-index: -999;
}

.bej2oR5RU_ySCJh8Q14y {
    position: absolute;
    top: 18px;
    left: 0;
    width: 50%;
    height: 0;
    border-bottom: 2px dashed var(--light-gray);
    z-index: -999;
}

.JbbP8_OB81elSdh9qfNc {
    position: absolute;
    top: 18px;
    left: 0;
    width: 100%;
    height: 0;
    border-bottom: 2px dashed var(--light-gray);
    z-index: -999;
}
`, "",{"version":3,"sources":["webpack://./src/RegistrationProgressBar.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,SAAS;IACT,2CAA2C;IAC3C,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,UAAU;IACV,SAAS;IACT,2CAA2C;IAC3C,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,SAAS;IACT,2CAA2C;IAC3C,aAAa;AACjB","sourcesContent":[".progressBar {\n    display: flex;\n    justify-content: space-between;\n    flex-grow: 1;\n    width: 100%;\n    margin: 40px 0 50px;\n}\n\n.phase {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n    width: 100%;\n    height: 80px;\n}\n\n.phaseName {\n    text-align: center;\n}\n\n.activeName {\n    color: var(--green);\n    font-weight: 600;\n}\n\n.leftLine {\n    position: absolute;\n    top: 18px;\n    right: 0;\n    width: 50%;\n    height: 0;\n    border-bottom: 2px dashed var(--light-gray);\n    z-index: -999;\n}\n\n.rightLine {\n    position: absolute;\n    top: 18px;\n    left: 0;\n    width: 50%;\n    height: 0;\n    border-bottom: 2px dashed var(--light-gray);\n    z-index: -999;\n}\n\n.fullLine {\n    position: absolute;\n    top: 18px;\n    left: 0;\n    width: 100%;\n    height: 0;\n    border-bottom: 2px dashed var(--light-gray);\n    z-index: -999;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"progressBar": `jTtkZVGH4D1cnboyBCmp`,
	"phase": `xr63LNqBNzOOyaZZIsN3`,
	"phaseName": `hkKMVgcP38woKcfnQErX`,
	"activeName": `iOVXaUW9_Wl5QZBM75Tn`,
	"leftLine": `UiAJuGhtSB1aAUowafI3`,
	"rightLine": `bej2oR5RU_ySCJh8Q14y`,
	"fullLine": `JbbP8_OB81elSdh9qfNc`
};
export default ___CSS_LOADER_EXPORT___;
